module.exports = __webpack_public_path__ + "img/help-step-1.3187d661.png";